
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/snehove-spravy",
      function () {
        return require("private-next-pages/[region]/snehove-spravy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/snehove-spravy"])
      });
    }
  